import { render, staticRenderFns } from "./DialoqBox.vue?vue&type=template&id=fae2b0e6&"
import script from "./DialoqBox.vue?vue&type=script&lang=ts&"
export * from "./DialoqBox.vue?vue&type=script&lang=ts&"
import style0 from "./DialoqBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports